<template>
  <div class="container-relation-indicator">
    <div class="header-indicator">
      <label>Indicadores da unidade: <strong>{{ selected }}</strong></label>
      <b-form-select class="formSelect" v-model="selected">
        <b-form-select-option v-for="(u, i) in options" :key="i" :value="u.value">
          {{ u.text }}
        </b-form-select-option>
      </b-form-select>
    </div>
    <div class="body-indicator">
      <div id="dropzone">
        <div class="table-header">
          <strong class="sub-title">PGDI</strong>
          <div class="search">
            <input type="text" name="name" v-model="filterPGDI" :placeholder="$t('digite-aqui-para-pesquisar')" />
          </div>
        </div>
        <hr>
        <div class="indicatos" v-if="pgdiBkp.length">
          <div class="indicator" draggable="true" v-for="indPGDI in PGDI" :key="`PGDI-${indPGDI.indicatorName}-${indPGDI.productionUnitId}-${indPGDI.indicatorId}`"
            :id="indPGDI.key" @dragstart="(event) => drag(event, indPGDI)">
            <p>{{ indPGDI.indicatorName }}</p>
          </div>
        </div>
        <div>
          <label>{{ $t('nao-ha-indicadores-recebidos-do-pgdi-selected', [selected]) }}</label>
        </div>
      </div>
      <div id="dropzone" @drop="drop" @dragover="allowDrop">
        <div class="table-header">
          <strong class="sub-title">{{ $t('gdi') }}</strong>
          <div class="search">
            <input type="text" name="name" v-model="filterGDI" :placeholder="$t('digite-aqui-para-pesquisar')" />
          </div>
        </div>
        <hr>
        <div class="indicatos" v-if="gdiBkp.length">
          <div class="indicatorGDI" v-for="indGDI in GDI" :key="`GDI-${indGDI.indicatorName}-${indGDI.productionUnitId}-${indGDI.indicatorId}`" 
          :id="indGDI.key" @dragstart="(event) => drag(event, indGDI)">
            <p> {{ indGDI.indicatorName }}</p>
          </div>
        </div>
      </div>
      <b-modal id="ConfirmTaskDuplication" 
        ok-variant="danger" 
        :title="$t('atencao')"
        :ok-title="$t('yes')" 
        :cancel-title="$t('no')" 
        @ok="forceIndicator()">
          {{ $t('o-indicador-selecionado-ja-esta-vinculado-a-um-indicador-do-gdi-deseja-inclui-lo-a-outro') }} 
      </b-modal>
    </div>
    <div class="groupBtn ">
      <img v-if="!saving" src="@/assets/salvar.png" :alt="$t('salvar')" style="margin-left: 30px; height:38px; cursor:pointer;"
        :title="$t('salvar')" @click="saveIndicatorRelateds($event)" />
      <b-spinner v-else class="spinner" label="Loading..."></b-spinner>
      <img src="@/assets/cancel.png" :alt="$t('cancelar')" style="margin-left: 30px; height:38px; cursor:pointer;"
        :title="$t('cancelar')" @click="$bvModal.show('confirmWeightRestore')" />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { urlMainAPI, defaultSuccess } from "@/global";
import Mediator from "./service/mediator"
import Kpi from "./model/kpi";

export default {
  name: "RelationalIndicator",
  data() {
    return {
      kpi: new Kpi({ row: this.row, column: this.column }),
      indicators: [],
      indicatorsBkp: [],
      loading: false,
      saving: false,
      cards: [],
      transiationKey: '',
      selected: null,
      options: [],
      units: [],
      json: [],
      PGDI: [],
      pgdiBkp: [],
      gdiBkp: [],
      GDI: [],
      relatedIndicator: [],
      filterPGDI: "",
      filterGDI: "",
    }
  },

  watch: {
    selected(value) {
      let valueSelected = this.json[Object.keys(this.json).find(key => key == value)];
      
      this.pgdiBkp = valueSelected ? JSON.parse(valueSelected.indicatorsPGDI).map(i => new Kpi(i)) : [];
      this.PGDI = this.pgdiBkp;
      this.gdiBkp = valueSelected ? JSON.parse(valueSelected.indicatorsGDI).map(i => new Kpi(i)) : [];
      this.GDI = this.gdiBkp;
   
      let indicators = {
        pgdi:this.PGDI,
        gdi:this.GDI,
        related: JSON.parse(valueSelected.relatedIndicators),
      }
      Mediator.notify(indicators, "loading");
    },

    filterPGDI() {
      this.PGDI = []
      if(this.filterPGDI){
        this.PGDI = this.pgdiBkp.filter(i => i.indicatorName.toLowerCase().includes(this.filterPGDI.toLowerCase()))
      }
      else
      {
        this.PGDI = this.pgdiBkp
      }
      Mediator.notify(this.PGDI, "refreshPgdiList")
    },

    filterGDI() {
      this.GDI = []
      if(this.filterGDI){
        this.GDI = this.gdiBkp.filter(i => {
          let hasPgdi = false;

          Mediator.kpisRelatedList
            .filter(j => j.gdiIndicatorId ==  i.indicatorId)
            .forEach(r => { 
              let pgdi = this.pgdiBkp.find(j => j.indicatorId == r.pgdiIndicadorId)
              if (pgdi) 
                hasPgdi = pgdi.indicatorName.toLowerCase().includes(this.filterGDI.toLowerCase()) || hasPgdi
            })

          return i.indicatorName.toLowerCase().includes(this.filterGDI.toLowerCase()) || hasPgdi
        })
      }
      else
      {
        this.GDI = this.gdiBkp
      }            
      
      Mediator.notify(this.GDI, "refreshGdiList")
    },
  },

  methods: {
    async loadRelatedIndicatorsByUnit() {
      this.loading = true
      const url = `${urlMainAPI}/getallrelatedindicatorsbyunit`;
      await axios.get(url).then((res) => {
        this.json = res.data;
        Object.keys(this.json).forEach(u => {
          this.options.push({text: u, value: u, disabled: false});
        });
        this.selected = this.options[0].value;
        
        this.loading = false
      }).catch((error) => {
        console.error(error)
      });
    },

    async saveIndicatorRelateds(){
      this.loading = true
      const url = `${urlMainAPI}/saverelatedindicators`;
      let relatedList = Mediator.kpisRelatedList.map(r => ({
        pgdiIndicadorId: r.pgdiIndicadorId.toString(),
        gdiIndicatorId: r.gdiIndicatorId.toString(),
        productionUnitId: r.productionUnitId.toString(),
      }));

      await axios.post(url, relatedList).then(res => {
        if(res.status == 200){
          defaultSuccess(res.data);
        }
      }).catch(console.error);
    },

    drag(event, kpi) {
      event.dataTransfer.setData("kpi", JSON.stringify(kpi))
    },

    drop(event) {
      let newKpiJSON = event.dataTransfer.getData("kpi");
      if (!newKpiJSON) return
      let source = JSON.parse(newKpiJSON)
      if (!source) {
        return
      }
      let target = event.target.id
      if (!target) {
        target = event.target.parentNode.id
      }
      if (!target) {
        return
      }
      let key = {
        pgdi: source.key,
        gdi: target,
        dialog: () => this.$bvModal.show("ConfirmTaskDuplication"),
        force: false,
      }
      this.transiationKey = key
      Mediator.notify(key, "insert")
    },

    forceIndicator() {
      this.transiationKey.force = true;
      Mediator.notify(this.transiationKey, "insert")
    },

    allowDrop(event) {
      if (this.blocked) return
      event.preventDefault()
    },

    select() {
      Mediator.notify(this, "insert")
    },
  },

  async mounted() {
    await this.loadRelatedIndicatorsByUnit();
  },
}
</script>


<style scoped>
p{
  margin: 0;
  text-indent: 1vh;
}

.body-indicator {
  display: flex;
  justify-content: space-between;
  padding: 0 8px;
  margin-top: 4px;
}

.formSelect {
  margin-top: 5px;
}

#dropzone > hr{
  margin: 4px 8px;
}

#dropzone {
  padding: 8px;
  min-width: 410px;
  width: 49%;
  height: 100%;
  box-shadow: 0 0 3px #0003;
  border-radius: 8px;
  overflow-y: hidden;

}

.sub-title{
  font-size: 1.5rem;
}

.container-relation-indicator {
  display: grid;
  grid-template-rows: 7vh 52.5vh 7vh;;
}

.table-header {
  display: flex;
  justify-content: space-between;
  padding: 0 8px;
}

.search > input{
  min-width: 225px;
}

.indicator {
  font-weight: 400;
  margin: 5px;
  cursor: pointer;
}
.indicatorGDI{
  font-weight: 490;
  margin: 5px;
  cursor: default;
}
.indicatorGDI:hover,
.indicator:hover {
  border-radius: 5px;
  background-color: #0002;
}

.select-indicatorList {
  background: #fefdfde7 !important;
  border: 1px solid #ff5f00;
  border-radius: 5px;
  text-indent: 1vh;
  margin: 5px;
}

.indicatos {
  height: calc(100% - 45px);
  overflow-y: auto;
  font-size: 1.2rem;
}

.groupBtn {
  margin-right: 3vh;
  margin-top: 1vh;
}

.header-indicator {
  display: flex;
  justify-content: space-between;
  padding: 0px 24px;
}

.header-indicator>select {
  width: 225px;
}

.header-indicator>label{
  font-size: 1.6rem;
}


@media only screen and (min-width: 1550px) {
  .container-relation-indicator {
    display: grid;
    grid-template-rows: 5vh 62.5vh 5.5vh;

  }
}
</style>

